import { NgModule } from '@angular/core';
import { AppHeaderComponent } from './app-header.component';
import { AppMenuComponent } from './app-menu/app-menu.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirectiveModule } from '../../directives/click-outside/click-outside-directive.module';

@NgModule({


  providers: [

  ],
  imports: [
    CommonModule,
    ClickOutsideDirectiveModule
  ],

})
export class AppHeaderComponentModule {
  constructor() { }
}
